// A workspace member, from the owner's Settings → Sharing (2026-10-17): what she is
// called in the app, and whether she is an admin (the whole app but what is his
// alone; internal/member admin.go is the list, and the server holds to it).
import { useState } from 'react'
import type { GrantResource } from '@/kinds/grant'
import { usePeople } from '@/db/hooks'
import { memberNameWith } from '@/lib/people'
import { mutate } from '@/runtime'
import { Button, Field, Sheet } from './ui'
import { SwitchRow } from './Switch'

export const MemberSheet = ({ grant, onClose }: { grant: GrantResource; onClose: () => void }) => {
  const [name, setName] = useState(grant.spec.member_name ?? '')
  const [error, setError] = useState('')
  const people = usePeople()
  const named = (member_name: string) => memberNameWith({ ...grant.spec, member_name }, people)
  const shown = named(name)
  const save = async (spec: Record<string, unknown>) => {
    setError('')
    try {
      await mutate.patch(grant.id, { spec })
    } catch (e) {
      setError((e as Error).message)
    }
  }
  return (
    <Sheet open onClose={onClose} title={named(grant.spec.member_name ?? '')}>
      <div className="flex flex-col gap-4" data-testid="member-sheet">
        <Field label="Name" hint={`Shown in the app and in what Prime says. Empty uses “${named('')}”.`}>
          <input
            value={name}
            maxLength={60}
            onChange={(e) => setName(e.target.value)}
            onBlur={() => {
              const next = name.trim()
              if (next !== (grant.spec.member_name ?? '')) void save({ member_name: next || null })
            }}
            placeholder={shown}
            data-testid="member-name"
          />
        </Field>
        <SwitchRow
          label="Admin"
          hint="Every app you have in your own suites, Settings with her own look and layout, and Dates, People, Calendar, Review and Music. Not the dev suite, agents, the factory, API tokens, security, sharing, or your wellbeing."
          on={!!grant.spec.admin}
          onChange={(on) => void save({ admin: on })}
          testId="member-admin"
        />
        {error && <p className="text-xs text-rose-300">{error}</p>}
        <Button variant="chip" onClick={onClose}>
          Done
        </Button>
      </div>
    </Sheet>
  )
}
